import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import zhCN from "@/i18n/locales/zh-CN.json";

export async function setupI18n(): Promise<void> {
  await i18n.use(initReactI18next).init({
    lng: "zh-CN",
    fallbackLng: "zh-CN",
    resources: {
      "zh-CN": { translation: zhCN },
    },
    interpolation: { escapeValue: false },
  });
}

export default i18n;
